type IHandleCalcAverage = {
  valorTotal: number;
  porcentagem: number | string;
  isDesconto?: boolean;
};

export const handleCalcAverage = ({
  valorTotal,
  porcentagem,
  isDesconto,
}: IHandleCalcAverage) => {
  const result = (valorTotal * Number(porcentagem)) / 100;

  if (isDesconto) {
    return String(valorTotal - result);
  }
  return result.toFixed(2);
};
